import { Logger } from '~~/helpers/logger';
import type { HitResultItem } from 'vue-instantsearch/vue3/es';
import { getEnergyRating } from '~~/helpers/product/energyRating';
import type { ProductCardItem } from '~~/types/product/ProductCardItem';

export const convertTypesenseProductsToCardProducts = (products: HitResultItem[]): ProductCardItem[] => {

  return products?.reduce((productCardItems: Array<ProductCardItem>, product: HitResultItem) => {

    if (product.objectID && product.name && product.price) {

      productCardItems.push(
        {
          ...product,
          fullProductPrice: product.basePrice || product.price,
          discountedPrice: product.basePrice ? product.price : undefined,
          last30DaysPrice: product.lowest30dPrice || null,
          hasDimensions: !!product.width && !!product.height && !!product.length,
          energyRatingDetails: getEnergyRating({ item: product }),
        },
      );

    } else {

      Logger.error(
        'convertTypesenseProductsToCardProducts',
        `Product with missing attributes provided by Typesense :
        objectId : ${product.objectID},
        name: ${product.name},
        price: ${product.price}
        `,
      );

    }

    return productCardItems;

  }, []);

};
